import { gql } from '@apollo/client';

export const DELETE_DORMITORY_NOTE = gql`
  mutation DeleteDormitoryNote($input: DeleteDormitoryNoteInput!) {
    deleteDormitoryNote(input: $input)
  }
`;
